module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('transition', {
    attrs: {
      "name": "highlight"
    }
  }, [(_vm.showHighlight) ? _c('div', {
    staticClass: "highlight"
  }) : _vm._e()]), _vm._v(" "), (_vm.charter.enabled) ? _c('h4', {
    staticClass: "margin-t-z margin-b-z"
  }, [_vm._v(_vm._s(_vm.$t('rsvpEdit.startDate')))]) : _c('h4', {
    staticClass: "margin-t-z margin-b-z"
  }, [_vm._v(_vm._s(_vm.$t('rsvpEdit.pickupDate2')))]), _vm._v(" "), _c('div', {
    staticClass: "pickup-info"
  }, [(_vm.charter.enabled) ? _c('div', {
    staticClass: "block-value"
  }, [_vm._v(_vm._s(_vm.startDate))]) : _c('div', {
    staticClass: "block-value"
  }, [_vm._v(_vm._s(_vm.pickupDate))])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a2fa625a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a2fa625a","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RsvpEdit/PickupInfo.vue
// module id = 2132
// module chunks = 0